exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".totop {\n  width: 60px;\n  height: 50px;\n  background: #3164e5;\n  position: fixed;\n  bottom: 250px;\n  right: 1%;\n  border-radius: 3px;\n  text-align: center;\n  padding: 5px 0;\n  cursor: pointer;\n  z-index: 99;\n}\n.totop img {\n  width: 8px;\n  transform: rotate(90deg);\n  display: block;\n  margin: 0 auto;\n}\n.totop span {\n  color: #fff;\n  margin-top: 10px;\n  font-size: 16px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/to-top/to-top.component.styl
// module id = ../../../../../src/app/share/to-top/to-top.component.styl
// module chunks = main